<template>
    <AccordionItem value="stock">
        <AccordionTrigger class="px-4 bg-gray-100">
            <span class="font-bold">{{ title }}</span>
            <NuxtLinkLocale to="/docs/stock-and-price-alerts/" target="_blank">
                <Icon name="circle-question" />
            </NuxtLinkLocale>
        </AccordionTrigger>
        <AccordionContent>
            <table class="table text-sm">
                <thead v-if="hasAlerts">
                    <tr class="text-left">
                        <th>{{ $t("Global.Quantity") }}</th>
                        <th>{{ $t("Notifications.IncreaseOrDecrease") }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <NotificationStockAlert
                        v-if="newAlert"
                        :alert="newAlert"
                        @save="onNewSave"
                        @cancel="newAlert = null" />
                    <NotificationAddRow v-else v-model="newAlert" colspan="2" />

                    <NotificationStockAlert
                        v-for="alert in props.alerts"
                        :key="alert.Id"
                        :alert
                        @save="emits('update', $event)"
                        @delete="emits('delete', $event)" />
                </tbody>
            </table>
        </AccordionContent>
    </AccordionItem>
</template>
<script setup lang="ts">
const { t } = useI18n();

const props = defineProps<{ alerts: StockAlert[] }>();
const emits = defineEmits<{
    add: [alert: StockAlert];
    update: [alert: StockAlert];
    delete: [id: number];
}>();

const newAlert = ref<StockAlert | null>(null);

const title = computed(() => t("Notifications.StockAlertsCount", [props.alerts.length]));
const hasAlerts = computed(() => props.alerts.length > 0 || newAlert.value != null);

function onNewSave(alert: StockAlert) {
    emits("add", alert);
    newAlert.value = null;
}
</script>
